import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Campañas',
  filters: {
    search: 'Buscar campañas...',
  },
  columns: {
    title: 'Título',
    created_by: 'Creado por',
    schedule_mode: 'Modo de programación',
    scheduled_at: 'Programado el',
    sent_at: 'Enviado el',
    status: 'Estado',
    sent: 'Enviado',
    delivered: 'Entregado',
    delivered_rate: 'Tasa de entrega',
    clicks: 'Clics',
    click_rate: 'Tasa de clics',
    live: 'En vivo',
    actions: 'Acciones',
  },
  active_status: {
    draft: 'Borrador',
    active: 'Activo',
  },
  delivery: {
    in_progress: 'Pendiente de confirmación',
    awaiting: 'Pendiente de confirmación',
    verified: 'Verificado {{relative}}',
    next_check_around: 'Próxima verificación alrededor de las {{time}}',
  },
  breakdown: {
    delivered: '{{count}} entregados',
    pending: '{{count}} pendientes de confirmación',
    failed_title: 'No entregado',
    all_delivered: 'Entregado a todos los destinatarios.',
    load_error: 'No se pudo cargar el desglose de entrega.',
    reasons: {
      DeviceNotRegistered: 'App eliminada o notificaciones desactivadas (token expirado)',
      MessageRateExceeded: 'Limitación temporal de velocidad por Expo',
      MessageTooBig: 'Carga de notificación demasiado grande',
      MismatchSenderId: 'Credenciales de push no coinciden',
      InvalidCredentials: 'Credenciales de push no válidas',
      batch_failed: 'Error al enviar el lote',
      missing_ticket: 'Sin confirmación de Expo',
      unknown: 'Error de entrega desconocido',
    },
  },
  created_by: {
    [CreatedBy.System]: 'Sistema',
    [CreatedBy.User]: 'Usuario',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Inmediato',
    [ScheduleMode.Scheduled]: 'Programado',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Enviando',
    [DeliveryStatus.Sent]: 'Enviado',
    [DeliveryStatus.Queued]: 'En cola',
    [DeliveryStatus.Failed]: 'Fallido',
  },
  actions: {
    details: 'Detalles',
    view_details: 'Ver detalles',
    resend: 'Reenviar',
    duplicate_edit: 'Duplicar y editar',
    delete: 'Eliminar',
    edit: 'Editar',
    activate: 'Activar',
    deactivate: 'Desactivar',
  },
  success_messages: {
    campaign_updated: 'Campaña actualizada correctamente',
    campaign_deleted: 'Campaña eliminada correctamente',
  },
  error_messages: {
    failed_to_update_campaign: 'Error al actualizar la campaña',
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_delete_campaign: 'Error al eliminar la campaña',
  },
};
